module.exports = __webpack_public_path__ + "static/media/standard.3ca45bbb.svg";